// Dependencies
import React, { useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDispatch } from "react-redux";

// Ag-Grid CSS
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

// Axios Component
import Axios from "../../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../../redux/features/appSlice";

function BatchDetailsTeacher(props) {
  // * Redux Variables
  const dispatch = useDispatch();

  // * State Variables
  const [filterData, setFilterData] = useState([]);

  // * Ag-Grid Column Definitions
  const columnHeader = [
    {
      headerName: "Teacher Id",
      field: "teacher_id",
      sortable: true,
      filter: true,
      hide:true,
    },
    {
      headerName: "Teacher Name",
      field: "teacher_name",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Languages",
      field: "teacherlanguages",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Group Name",
      field: "batch_name",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Group Id",
      field: "group_id",
      sortable: true,
      filter: true,
      hide:true,
    },
    {
      headerName: "Group Status",
      field: "group_status",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Teacher Mapped Status",
      field: "teacher_mapped_status",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Mapped To Student",
      field: "mapped_to_student",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Teacher Status",
      field: "teacher_status",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Role",
      field: "role",
      sortable: true,
      filter: true,
    },
  ];

  // ? Get Method : Get All Particular Batch Teachers Details
  const onGridReady = async (params) => {
    try {
      setFilterData(params.api);

      let options = {
        method: "GET",
        url: `/batchview/teacherlist/batch/${props.id}`,
        auth: true,
        data: null,
      };

      let response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      params.api.applyTransaction({ add: response.data });
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Error occurred! Unable to fetch data.",
          severity: "error",
        })
      );
    }
  };

  // * Filter Box
  const onFilterTextChange = (e) => {
    filterData.setQuickFilter(e.target.value);
  };

  return (
    <div>
      <h5 className="mt-5">Teachers Included</h5>

      <div className="my-2">
        <input
          type="search"
          name="search"
          placeholder="Search"
          style={{
            width: "200px",
            padding: "10px",
            border: "1px solid #1D3FAA",
            borderRadius: "20px",
            outline: "none",
          }}
          onChange={onFilterTextChange}
        />
      </div>

      <div
        className="ag-theme-alpine my-3"
        style={{ width: "100%", height: "350px" }}
      >
        <AgGridReact
          onGridReady={onGridReady}
          columnDefs={columnHeader}
          pagination={true}
          paginationAutoPageSize={true}
        />
      </div>
    </div>
  );
}

export default BatchDetailsTeacher;
